import { toRaw } from 'vue';

const toRawDeep = (value) => {
  const item = toRaw(value);

  if (Array.isArray(item)) {
    return item.map(toRawDeep);
  }

  if (item === null) {
    return null;
  }

  if (typeof item === 'object') {
    const entries = Object.entries(item).map(([key, val]) => [key, toRawDeep(val)]);

    return Object.fromEntries(entries);
  }

  return item;
};

export default toRawDeep;
